import { NEWPropertyOwnership } from '@guiker/real-estate-shared'

export const getPropertyAddress = (property: NEWPropertyOwnership['property']) => {
  const { mailingAddress: address } = property.building
  const { units, unit } = property as any

  return {
    ...address,
    suite: units?.[0]?.suite ?? unit?.suite,
    streetNumber: address.streetNumber,
    postalCode: address.zipcode,
  }
}
